import { render, staticRenderFns } from "./ExperienceDetails.vue?vue&type=template&id=6810d040&"
import script from "./ExperienceDetails.vue?vue&type=script&lang=js&"
export * from "./ExperienceDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExperienceDetails.vue?vue&type=style&index=0&id=6810d040&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports